import { makeAutoObservable, observable } from "mobx";

const DEFAULT_PAGE_SIZE = 5;

class ConsolidatedOrgDetailPanelState {
  pivot = null;
  rows = [];
  total = 0;
  orgMeta = null;
  parentLevelMetrics = [];
  page = 1;
  pageSize = DEFAULT_PAGE_SIZE;
  search = "";
  statuses = [];
  drillFrameworks = [];
  drillCategories = [];
  loading = false;
  hasLoadedOnce = false;

  constructor(pivot) {
    this.pivot = pivot;
    this.loading = true;
    makeAutoObservable(this);
  }

  setResult = (data) => {
    this.rows = data?.rows ?? [];
    this.total = Number(data?.total ?? 0);
    this.orgMeta = data?.orgMeta ?? null;
    this.parentLevelMetrics = Array.isArray(data?.parentLevelMetrics)
      ? data.parentLevelMetrics
      : [];
    this.page = Number(data?.page ?? this.page);
    this.pageSize = Number(data?.pageSize ?? this.pageSize);
    this.hasLoadedOnce = true;
  };

  setLoading = (value) => {
    this.loading = Boolean(value);
  };

  setSearch = (value) => {
    this.search = value ?? "";
    this.page = 1;
  };

  setStatuses = (value) => {
    this.statuses = Array.isArray(value) ? value : [];
    this.page = 1;
  };

  setDrillFrameworks = (value) => {
    this.drillFrameworks = Array.isArray(value) ? value : [];
    this.page = 1;
  };

  setDrillCategories = (value) => {
    this.drillCategories = Array.isArray(value) ? value : [];
    this.page = 1;
  };

  setPageSize = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1) return;
    this.pageSize = n;
    this.page = 1;
  };

  setPage = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1) return;
    this.page = n;
  };
}

class DashboardConsolidatedOrgDetailStore {
  expandedKeys = observable.set();
  panels = observable.map();

  constructor() {
    makeAutoObservable(this, {
      expandedKeys: observable,
      panels: observable,
    });
  }

  toggle = ({ orgId }) => {
    if (this.expandedKeys.has(orgId)) {
      this.collapse(orgId);
    } else {
      this.expand({ orgId });
    }
  };

  expand = ({ orgId }) => {
    this.expandedKeys.add(orgId);
    this.panels.set(orgId, new ConsolidatedOrgDetailPanelState({ orgId }));
  };

  collapse = (key) => {
    this.expandedKeys.delete(key);
    this.panels.delete(key);
  };

  collapseAll = () => {
    this.expandedKeys.clear();
    this.panels.clear();
  };

  isExpanded = (key) => this.expandedKeys.has(key);

  getPanel = (key) => this.panels.get(key);
}

export const dashboardConsolidatedOrgDetailStore =
  new DashboardConsolidatedOrgDetailStore();
